import { createSlice } from "@reduxjs/toolkit";
import { addPartyApi} from "../api/settings";

interface SettingsState {
  loading: boolean;
  currentRequestId: undefined | string;
  userData: any;
  error: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  userData: null,
  error: null,
} as SettingsState;
 export const settingsSlice = createSlice({
    name: 'settings',
    initialState,
    reducers:{
        resetSettings: () => initialState,
      },
    extraReducers(builder) {
        builder
        .addCase(addPartyApi.pending, (state, action) => {
            state.loading = true;
            state.currentRequestId = action.meta.requestId;
          })
          .addCase(addPartyApi.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
            }
          })
          .addCase(addPartyApi.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.loading && state.currentRequestId === requestId) {
              state.loading = false;
              state.currentRequestId = undefined;
              state.error = action.error;
            }
          })
        
    }
 })

 export const { resetSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
